import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { useMemo } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { DisplayPriceGettingSpecificPriceParams } from '../../../../../../../../../../baseComponents/Displays/DisplayPrice'
import { TitleSButtonPermissioned } from '../../../../../../../../../../baseComponents/Layout/TitleAndRightLayout'
import { TwinSimpleTable } from '../../../../../../../../../../baseComponents/TwinTable'
import { ColumnTableSchema } from '../../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { SpecificPriceRulesPayload } from '../../../../../../../../../../utils/reducers/products/specificPriceRules'
import { ProductExtendedTyLong } from '../../../../../../../../../Product/types'

interface  ProductComposedOrderTabProps  {
    basicData: CustomerModelType
}

const ProductComposedOrderTab: React.FC<ProductComposedOrderTabProps & ReduxSpecificPricesTable> = ({ specificPriceRules, basicData }) => {
    const { t } = useTwinTranslation()
    const defaultSpecificPriceRuleId = useMemo(() => {
        const specificPriceRulesSorted = specificPriceRules?.arrSorted || []
        return specificPriceRulesSorted?.[0]?.id
    }, [specificPriceRules?.arrSorted])

    const columns: ColumnTableSchema<ProductExtendedTyLong> = [
        {
            id: 'ProductsComposedId',
            dataKey: 'ProductsComposedId',
            label: t('id', 'ID'),
            width: 50,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'units',
            dataKey: 'units',
            label: t('units', 'Unidades'),
        },
        {
            id: 'price',
            dataKey: 'SpecificPriceRuleId',
            label: (props) => {
                const myValue = parseInt(props.selectedFilterValue || props.value || defaultSpecificPriceRuleId)
                return <span>{t('price', 'Precio') + ' (' + (specificPriceRules?.dictionary?.[myValue]?.name || t('notSelectedPriceRule', 'Sin tarifa selec.')) + ')'} </span>
            },
            simpleLabel: t('price', 'Precio'),
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: { items: specificPriceRules?.dictionary || {}, label: t('specificPriceRule', 'Tarifa') }
            },
            generalSearchable: false,
            customRender: (_parameterValue, allRowData) => {
                return <DisplayPriceGettingSpecificPriceParams value={allRowData?.calculated_price} CurrencyId={specificPriceRules?.dictionary[allRowData.SpecificPriceRuleId]?.CurrencyId || ''} with_vat={false} specificPriceRules={specificPriceRules} SpecificPriceRuleId={defaultSpecificPriceRuleId} />
            }
        }
    ]
    return (
        <TitleSButtonPermissioned title={t('productComposed', 'Producto Compuesto')} buttonText={t('save', 'Guardar')} userPermissions={{ n: 1, permission: 'read' }} permission='update'>
            <TwinSimpleTable columns={columns} name='subProductComposed' getDataFrom='/api/app/product/productComposed/getAllProductsComposedComplete' defaultOrder={{ 'defaultOrderField': 'ProductId' }} extraWhereParams={{
                'ProductComposed.ProductId': basicData?.id
            }} extraWhereSubstituibleParams={{ 'SpecificPriceRuleId': defaultSpecificPriceRuleId }} />
        </TitleSButtonPermissioned>
    )
}

const productComposedTableDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

type ReduxSpecificPricesTable = ConnectedProps<typeof productComposedTableConnect>
const mapProductComposedTableConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const productComposedTableConnect = connect(mapProductComposedTableConnector, productComposedTableDispatch)

const productComposedTableConnectLoading = withLoading(ProductComposedOrderTab, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])

const ProductComposedOrderTabConnect = productComposedTableConnect(productComposedTableConnectLoading)

export default ProductComposedOrderTabConnect